
import { createSlice } from "@reduxjs/toolkit";


const careerSlice = createSlice({
    name: 'career',
    initialState: {
        loading: false,
    },
    reducers: {
        carrerAllLoading(state, action) {
            return {
                loading: true,
            }
        },
        carrerAllSuccess(state, action) {
            return {
                loading: false,
                allCareer: action.payload.applications || action.payload.allCareer || [],
            }
        },
        carrerAllFail(state, action) {
            return {
                loading: false,
                error: action.payload
            }
        },
        carrerGetSingleLoading(state, action) {
            return {
                loading: true,
            }
        },
        carrerGetSingleSuccess(state, action) {
            return {
                loading: false,
                singlejobpost: action.payload.singlecareer,
            }
        },
        carrerGetSingleFail(state, action) {
            return {
                loading: false,
                error: action.payload
            }
        },
    }
})

const { actions, reducer } = careerSlice;

export const {
    carrerAllLoading, carrerAllSuccess, carrerAllFail, carrerGetSingleLoading, carrerGetSingleSuccess, carrerGetSingleFail
} = actions;


export default reducer;
